import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { ModalPage as DefaultModalPage } from '@xing-com/modal-page';

export const ModalPage = styled(DefaultModalPage)`
  max-height: 100vh;
  max-height: 100dvh;
  overflow: auto;

  @media ${mediaSmallOrTiny} {
    [data-xds='ClosingIndicator'] {
      display: none;
    }
  }
`;
